import { ConvertListPage } from "@/features/convert/pages/ConvertList";
import { ConvertFilterCacheProvider } from "@/features/convert/provider/ConvertListFilterCacheProvider";

function ConvertList() {
  return (
    <ConvertFilterCacheProvider>
      <ConvertListPage />
    </ConvertFilterCacheProvider>
  );
}

export default ConvertList;
